module.exports = __webpack_public_path__ + "89269bc2ca5316a478672ac34f456785.svg";